import { render, staticRenderFns } from "./FormCadastroSucesso.vue?vue&type=template&id=4efcce30"
import script from "./FormCadastroSucesso.vue?vue&type=script&lang=js"
export * from "./FormCadastroSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports